import LocationIcon from '../BaseComponents/LocationIcon';
import { CartSiteAddress } from '../CartProvider';

const CurrentLocationHeader = ({
  activeLocation,
  type,
}: {
  activeLocation: CartSiteAddress;
  type: string;
}) => {
  return (
    <div className="flex flex-col justify-between sm:flex-row">
      <p className="flex items-center gap-2">
        <LocationIcon />
        <span className="font-bold text-content-base-default">
          {activeLocation?.address_line_1}, {activeLocation?.city},{' '}
          {activeLocation?.state} {activeLocation?.zip}
        </span>
      </p>
      <div
        className={`ml-4 max-h-6 max-w-[85px] whitespace-nowrap rounded-lg px-2 py-1 text-xs font-bold text-black ${
          type === 'broadband' ? 'bg-green-300' : 'bg-blue-400'
        }`}
      >
        {type}
      </div>
    </div>
  );
};

export default CurrentLocationHeader;
